import { Settings, Shield, FileText, Heart, Download, Trash2 } from 'lucide-react';
import { useAppStore } from '../../store/useAppStore';
import { NotificationSettings } from '../NotificationSettings';

export const SettingsModal = () => {
  const { openModal, logout } = useAppStore();

  const settingsSections = [
    {
      title: 'Legal & Privacy',
      items: [
        {
          icon: FileText,
          label: 'Terms of Service',
          action: () => openModal('terms'),
          description: 'View our terms and conditions'
        },
        {
          icon: Shield,
          label: 'Privacy Policy',
          action: () => openModal('privacy'),
          description: 'Learn how we protect your data'
        },
        {
          icon: Heart,
          label: 'AI Ethics',
          action: () => openModal('ethics'),
          description: 'Our commitment to ethical AI'
        }
      ]
    },
    {
      title: 'Data Management',
      items: [
        {
          icon: Download,
          label: 'Export Data',
          action: () => alert('Export feature coming soon!'),
          description: 'Download your data'
        },
        {
          icon: Trash2,
          label: 'Clear Local Data',
          action: () => {
            if (confirm('This will clear all local data. Continue?')) {
              localStorage.clear();
              window.location.reload();
            }
          },
          description: 'Remove all cached data',
          destructive: true
        }
      ]
    }
  ];

  return (
    <div className="p-6 space-y-6">
      {/* Settings Header */}
      <div className="card p-6">
        <div className="flex items-center space-x-3 mb-4">
          <Settings className="w-6 h-6 text-brand" />
          <h3 className="text-xl font-semibold text-th-primary">
            App Settings
          </h3>
        </div>
        <p className="text-th-secondary">
          Manage your preferences and data settings.
        </p>
      </div>

      {/* Settings Sections */}
      {settingsSections.map((section, _) => (
        <div key={section.title} className="card p-6">
          <h4 className="text-lg font-semibold text-th-primary mb-4">
            {section.title}
          </h4>
          <div className="space-y-3">
            {section.items.map((item, _) => (
              <button
                key={item.label}
                onClick={item.action}
                className={`w-full flex items-center space-x-3 p-4 rounded-xl transition-all hover:scale-105 ${
                  item.destructive
                    ? 'bg-status-error/10 hover:bg-status-error/20 border border-status-error/20'
                    : 'bg-surface hover:bg-overlay'
                }`}
              >
                <item.icon className={`w-5 h-5 ${item.destructive ? 'text-status-error' : 'text-brand'}`} />
                <div className="flex-1 text-left">
                  <p className={`font-medium ${item.destructive ? 'text-status-error' : 'text-th-primary'}`}>
                    {item.label}
                  </p>
                  <p className="text-th-secondary text-sm">
                    {item.description}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      ))}

      {/* Notification Settings */}
      <NotificationSettings />

      {/* Logout Section */}
      <div className="bg-elevated border border-subtle rounded-xl p-6">
        <button
          onClick={logout}
          className="w-full flex items-center justify-center space-x-2 p-4 bg-overlay hover:bg-muted border border-subtle rounded-xl transition-all hover:scale-105"
        >
          <span className="text-status-error font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
};
